/** @format */

import React from "react";
import { Container } from "../../components/layouts/Container";
import { Box } from "../../components/layouts/Box";
import { TitleElement, ExminationCancelBarElement, BcartExaminationStatusElement } from "../../components/ui_elements";
import useExaminationStatusHooks from "../../hooks/useExaminationStatusHooks";
import { BackButton } from "../../components/ui-parts";
import useNavigateByAgent from "../../hooks/useNavigateByAgentHooks";

const BcartExaminationStatus = () => {
  const { navigateByAgent } = useNavigateByAgent();
  const { allServiceData, serviceCodeList, creditOrderArray, serviceStopFlag } =
    useExaminationStatusHooks(navigateByAgent);
  return (
    <Container isLogin isInquiry>
      <TitleElement />
      <div className="mb8 align_right display-mobile">
        <BackButton onClick={() => navigateByAgent("/dashboard")}>ダッシュボードに戻る</BackButton>
      </div>
      <ExminationCancelBarElement />
      <Box mt={18} />
      <BcartExaminationStatusElement
        examination={allServiceData}
        serviceCodeList={serviceCodeList}
        creditOrderArray={creditOrderArray}
        serviceStopFlag={serviceStopFlag}
      />
    </Container>
  );
};

export default BcartExaminationStatus;
